<template>
    <div>
        <h2>
            Profil

            <a href="#" v-if="! editing" @click.prevent="deleteUser" class="float-right action" title="Zmazať">
                <i class="fa fa-trash-o"></i>
            </a>
            <a href="#" v-if="! editing" @click.prevent="editing = true" class="float-right action pr-4" title="Upraviť">
                <i class="fa fa-edit"></i>
            </a>

            <a :href="'/admin/users/sign-in-as/' + user.institutions[0].id"
               v-if="canSignIn" class="float-right action pr-4" title="Prihlásiť sa">
                <i class="fa fa-user"></i>
            </a>
        </h2>

        <form @keydown="submitted = false"
              autocomplete="off"
              class="form-horizontal form-bordered form-row-stripped">
            <div class="form-group">
                <label class="control-label col-md-3">ID</label>
                <div class="col-md-9">
                    <input class="form-control-plaintext"
                           readonly="true"
                           type="text"
                           v-bind:value="user.id">
                </div>
            </div>

            <div class="form-group">
                <label class="control-label col-md-3">E-mail</label>
                <div class="col-md-9">
                    <input class="form-control-plaintext"
                           readonly
                           type="text"
                           v-model="form.email">
                </div>
            </div>

            <div v-bind:class="[errors.name ? 'has-error' : '', 'form-group']">
                <label for="inputName" class="control-label col-md-3">Meno a priezvisko</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.name ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="name"
                           autocomplete="new-password"
                           @keydown="delete errors.name; submitted = false"
                           id="inputName"
                           v-model="form.name">
                    <span class="help-block"
                          v-text="errors.name[0]"
                          v-if="errors.name"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.address ? 'has-error' : '', 'form-group']">
                <label for="inputAddress" class="control-label col-md-3">Adresa</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.address ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           autocomplete="new-password"
                           type="text"
                           name="address"
                           id="inputAddress"
                           @keydown="delete errors.address; submitted = false"
                           v-model="form.address">
                    <span class="help-block"
                          v-text="errors.address[0]"
                          v-if="errors.address"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.city ? 'has-error' : '', 'form-group']">
                <label for="inputCity" class="control-label col-md-3">Mesto</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.city ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="city"
                           autocomplete="new-password"
                           id="inputCity"
                           @keydown="delete errors.city; submitted = false"
                           v-model="form.city">
                    <span class="help-block"
                          v-text="errors.city[0]"
                          v-if="errors.city"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.zip ? 'has-error' : '', 'form-group']">
                <label for="inputZip" class="control-label col-md-3">PSČ</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.zip ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="zip"
                           autocomplete="new-password"
                           @keydown="delete errors.zip; submitted = false"
                           id="inputZip"
                           v-model="form.zip">
                    <span class="help-block"
                          v-text="errors.zip[0]"
                          v-if="errors.zip"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.company ? 'has-error' : '', 'form-group']">
                <label for="inputCompany" class="control-label col-md-3">Firma</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.company ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="company"
                           @keydown="delete errors.company; submitted = false"
                           id="inputCompany"
                           v-model="form.company">
                    <span class="help-block"
                          v-text="errors.company[0]"
                          v-if="errors.company"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.ico ? 'has-error' : '', 'form-group']">
                <label for="inputIco" class="control-label col-md-3">IČO</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.ico ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="ico"
                           @keydown="delete errors.ico; submitted = false"
                           id="inputIco"
                           v-model="form.ico">
                    <span class="help-block"
                          v-text="errors.ico[0]"
                          v-if="errors.ico"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.dic ? 'has-error' : '', 'form-group']">
                <label for="inputDic" class="control-label col-md-3">DIČ</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.dic ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="dic"
                           @keydown="delete errors.dic; submitted = false"
                           id="inputDic"
                           v-model="form.dic">
                    <span class="help-block"
                          v-text="errors.dic[0]"
                          v-if="errors.dic"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.icdph ? 'has-error' : '', 'form-group']">
                <label for="inputIcDph" class="control-label col-md-3">IČ DPH</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.icdph ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="icdph"
                           @keydown="delete errors.icdph; submitted = false"
                           id="inputIcDph"
                           v-model="form.icdph">
                    <span class="help-block"
                          v-text="errors.icdph[0]"
                          v-if="errors.icdph"
                    ></span>
                </div>
            </div>

            <div v-bind:class="[errors.phone ? 'has-error' : '', 'form-group']">
                <label for="inputPhone" class="control-label col-md-3">Telefón</label>
                <div class="col-md-9">
                    <input v-bind:class="[errors.phone ? 'is-invalid' : '', editing ? 'form-control' : 'form-control-plaintext']"
                           v-bind:readonly="! editing"
                           type="text"
                           name="phone"
                           autocomplete="new-password"
                           id="inputPhone"
                           @keydown="delete errors.phone; submitted = false"
                           v-model="form.phone">
                    <span class="help-block"
                          v-text="errors.phone[0]"
                          v-if="errors.phone"
                    ></span>
                </div>
            </div>

            <div class="form-group">
                <label class="control-label col-md-3">Dátum vytvorenia</label>
                <div class="col-md-9">
                    <input class="form-control-plaintext"
                           readonly="true"
                           type="text"
                           name="name"
                           v-bind:value="createdAt">
                </div>
            </div>

            <div class="form-group">
                <label class="control-label col-md-3">Naposledy upravené</label>
                <div class="col-md-9">
                    <input class="form-control-plaintext"
                           readonly="true"
                           type="text"
                           name="name"
                           v-model="updatedAt">
                </div>
            </div>

            <div class="form-group">
                <label class="control-label col-md-3">Naposledy aktívny</label>
                <div class="col-md-9">
                    <input class="form-control-plaintext"
                           readonly="true"
                           type="text"
                           name="name"
                           v-model="lastLoginAt">
                </div>
            </div>

            <div class="form-actions mb-4">
                <div class="row">
                    <div class="col-md-offset-3 col-md-9">
                            <button v-if="editing" :disabled="submitted" type="button" class="btn btn-primary mr-2" v-on:click="submit">
                                Uložiť
                            </button>
                            <button v-if="editing" type="button" class="btn btn-default mr-2" v-on:click="editing = false">
                                Zrušiť
                            </button>
                            <button type="button" class="btn btn-info mr-2" v-on:click="resetPassword()">
                                Resetovať heslo
                            </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['user'],

        data() {
            return {
                form: {
                    name: this.user.name,
                    email: this.user.email,
                    address: this.user.address,
                    city: this.user.city,
                    zip: this.user.zip,
                    company: this.user.company,
                    ico: this.user.ico,
                    dic: this.user.dic,
                    icdph: this.user.icdph,
                    phone: this.user.phone,
                },
                editing: false,
                submitted: false,
                errors: {}
            }
        },

        methods: {
            submit() {
                this.submitted = true;

                axios.patch('/admin/users/' + this.user.id, this.form)
                    .then(() => {
                        flash('Zmeny uložené.');
                        this.editing = false;
                    }).catch(errors => {
                        this.errors = errors.response.data.errors;
                });
            },

            resetPassword() {
                if (confirm('Naozaj chcete resetovať heslo a poslať pokyny používateľovi e-mailom?')) {
                    axios.post('/admin/users/' + this.user.id + '/reset-password')
                        .then(() => {
                            flash('Nové heslo bolo zaslané na <b>' + this.user.email + '</b>.');
                        }).catch(errors => {
                        flash(errors.response.data.message, 'danger');
                    });
                }
            },

            deleteUser() {
                if (confirm('Zrušenie používateľa odstráni aj zrealizované objednávky kurzov. Pokračovať?')) {
                    axios.delete('/admin/users/' + this.user.id)
                        .then(() => {
                            flash('Používateľ <b>' + this.user.email + '</b> bol zmazaný.');
                            window.location = '/admin/users';
                        }).catch(errors => {
                            flash(errors.response.data.message, 'danger');
                    });
                }
            }
        },

        computed: {
            canSignIn: function () {
                return ! this.editing &&
                    (typeof this.user.institutions !== 'undefined' && this.user.institutions.length > 0);
            },
            createdAt: function() {
                return this.user.created_at != undefined ? moment(this.user.created_at).format('D.M.YYYY, H:mm') : '';
            },
            updatedAt: function() {
                return this.user.updated_at != undefined ? moment(this.user.updated_at).format('D.M.YYYY, H:mm') : '';
            },
            lastLoginAt: function() {
                return this.user.last_login_at != undefined ? moment(this.user.last_login_at).format('D.M.YYYY, H:mm') : '(nikdy)';
            }
        }
    }
</script>

<style scoped>
    i.fa-edit {
        margin-top: 7px !important;
    }
</style>
